import { LitElement, PropertyValues } from 'lit'
import { property } from 'lit/decorators.js'

import { ElementSpacing, Size } from '@/common/types'
import { setFromParentSize } from '@/common/utils'

type Constructor<T = Record<string, unknown>> = {
  new (...args: any[]): T
  prototype: T
}

export interface SizedElementInterface {
  size: Size
  parentSized: string
  spacing: ElementSpacing
}

export function SizedMixin<T extends Constructor<LitElement>>(
  constructor: T,
): T & Constructor<SizedElementInterface> {
  class SizedElement extends constructor {
    @property() size: Size = 'sm'
    @property() parentSized = 'false'
    @property() spacing: ElementSpacing = 'none'

    protected override update(changes: PropertyValues): void {
      if (!this.hasAttribute('size')) {
        this.setAttribute('size', this.size)
      }

      if (this.parentSized === 'true') {
        setFromParentSize(this)
      }

      super.update(changes)
    }
  }
  return SizedElement as Constructor<SizedElementInterface> & T
}
